import { ReactNode, useCallback, useMemo } from 'react';
import { useModalStore } from 'shared/hooks/stores/useModalStore';

type Fn = (closeModal: () => void) => ReactNode;

export const useModal = () => {
  const pushModal = useModalStore((state) => state.pushModal);
  const removeModal = useModalStore((state) => state.removeModal);
  const modals = useModalStore((state) => state.modals);

  const isAnyModalDisplayed = useMemo(() => !!modals.length, [modals]);

  const openModal = useCallback(
    (id: string, content: ReactNode | Fn) => {
      if (typeof content === 'function') {
        pushModal(
          id,
          content(() => removeModal(id)),
        );
        return;
      }
      pushModal(id, content);
    },
    [pushModal],
  );

  return {
    openModal,
    closeModal: removeModal,
    isAnyModalDisplayed,
  };
};
